<script lang="ts">
  import { observe } from "$lib/actions/observe";

  let {
    sectionLabel = "",
    headline = "",
    testimonials = [] as Array<{
      quote: string;
      author: string;
      role: string;
    }>
  } = $props();
</script>

<section>
  <div class="container">
    {#if sectionLabel}
      <div class="section-divider fade-up" use:observe>
        <span class="section-label">{sectionLabel}</span>
        <h2>{headline}</h2>
      </div>
    {/if}
    {#each testimonials as testimonial}
      <div class="testimonial fade-up" use:observe>
        <blockquote>„{testimonial.quote}"</blockquote>
        <cite>— <strong>{testimonial.author}</strong>, {testimonial.role}</cite>
      </div>
    {/each}
  </div>
</section>
